import { z } from 'zod';
import { IsoDateTime, Uuid } from './common';

export const TokenScope = z
  .enum(['read', 'read_write'])
  .describe('`read` allows only GET/HEAD; `read_write` allows everything the owner role allows.');
export type TokenScope = z.infer<typeof TokenScope>;

export const ApiToken = z
  .object({
    id: Uuid,
    name: z.string(),
    prefix: z.string().describe('First characters of the token, to recognise it.'),
    scope: TokenScope,
    owner: z.object({ id: Uuid, name: z.string() }),
    createdAt: IsoDateTime,
    lastUsedAt: IsoDateTime.nullable(),
    revokedAt: IsoDateTime.nullable(),
  })
  .meta({
    id: 'ApiToken',
    example: {
      id: '0d6d7b38-0e0a-4c39-8c4e-9d8c7a6b5e41',
      name: 'Claude MCP',
      prefix: 'dz_a1b2c3',
      scope: 'read',
      owner: { id: '5b0c6f9e-2d3a-4a51-9a52-4f0d3c8a1b11', name: 'Lucas' },
      createdAt: '2026-10-06T12:00:00.000Z',
      lastUsedAt: null,
      revokedAt: null,
    },
  });
export type ApiToken = z.infer<typeof ApiToken>;

export const ApiTokenList = z.object({ data: z.array(ApiToken) });

export const CreateApiTokenBody = z
  .object({
    name: z.string().trim().min(1).max(80),
    scope: TokenScope,
  })
  .meta({ example: { name: 'Claude MCP', scope: 'read' } });
export type CreateApiTokenBody = z.infer<typeof CreateApiTokenBody>;

export const CreateApiTokenResponse = z.object({
  token: ApiToken,
  secret: z
    .string()
    .describe('The full token. Shown only once; send as `Authorization: Bearer <secret>`.'),
});
export type CreateApiTokenResponse = z.infer<typeof CreateApiTokenResponse>;
